import React, { Component, Fragment } from 'react'
import { Button, Popconfirm, Popover, Steps } from 'antd'
import ProjectDetail from '../../../components/Project/Projects/Form/ProjectDetail'
import GroupList from '../../../components/Project/Projects/Form/GroupList'
import NewGroup from '../../../components/Project/Projects/Form/NewGroup'

const Step = Steps.Step

class ProjectForm extends Component {
  render () {
    const { current, next, prev, confirmLoading, projectRef, groupRef, groupMemberRef } = this.props

    const customDot = (dot, { status, index }) => (
      <Popover
        content={
          <span>
            step {index} status: {status}
          </span>
        }>
        {dot}
      </Popover>
    )

    const StepsAction = () => (
      <div
        className="steps-action"
        style={current !== steps.length - 1 ? { margin: '9px 35% 17px 44%' } : { margin: '9px 31% 17px 36%' }}>
        {current > 0 && (
          <Button style={{ marginLeft: 8 }} onClick={prev}>
            Previous
          </Button>
        )}
        {current < steps.length - 1 &&
        (steps[current].confirmation ? (
          <Popconfirm
            title={steps[current].confirmation}
            onConfirm={next}
            okText="Create"
            cancelText="Cancel"
            style={{ marginLeft: 17 }}>
            <Button loading={confirmLoading} type="primary" style={{ marginLeft: 17 }}>
              {steps[current].nextText ? steps[current].nextText : 'Next'}
            </Button>
          </Popconfirm>
        ) : (
          <Button loading={confirmLoading} type="primary" style={{ marginLeft: 17 }} onClick={next}>
            {steps[current].nextText ? steps[current].nextText : 'Next'}
          </Button>
        ))}
        {current === steps.length - 1 && (
          <Button type="primary" onClick={next} style={{ marginLeft: 17 }}>
            Complete Registration !
          </Button>
        )}
      </div>
    )
    const steps = [
      {
        title: 'Project Details',
        content: <ProjectDetail {...this.props} ref={projectRef}/>,
        index: 0,
      },
      {
        title: 'Existing Group Details',
        content: <GroupList {...this.props} ref={groupRef}/>,
        index: 1,
        nextText: 'Create New',
        confirmation: 'Are you sure you don\'t want to use preexisting group?',
      },
      {
        title: 'Create New Group',
        content: <NewGroup {...this.props} ref={groupMemberRef}/>,
        index: 2,
      },
    ]

    const StepsProgressDots = () => (
      <Steps current={current} progressDot={customDot}>
        {steps.map((item) => (
          <Step key={item.title} title={item.title}/>
        ))}
      </Steps>
    )

    let content = ''
    try {
      content = steps[current].content
    } catch (e) {
      content = ''
    }

    return (
      <Fragment>
        <StepsProgressDots/>
        <StepsAction/>
        {<div className="steps-content">{content}</div>}
      </Fragment>
    )
  }
}

export default ProjectForm
